import React from 'react';
import { connect } from 'react-redux';
import 'src/pages/Analytics/Analytics.css';
import { sessionCheck } from 'src/actions/user';
import DonutChartCard from 'src/components/analytics/DonutChartCard';
import User from 'src/models/User';
import TenantStats from 'src/models/TenantStats';
import { StringUtils } from 'src/util/StringUtils';
import Tenant from 'src/models/Tenant';
import { handleErrorWithDialog } from 'src/util/Errors';
import { TrackingAnalytics } from 'src/analytics/TrackingAnalytics';
import devices from 'src/images/devices.png';
import arrows from 'src/images/arrows.svg';
import ActiveUsers from 'src/components/analytics/ActiveUsers';
import ActivitiesByUseCase from 'src/components/analytics/ActivitiesByUseCase';
import ActiveHeroes from 'src/components/analytics/ActiveHeroes';
import StatsOverview from 'src/components/analytics/StatsOverview';
import PopinsBreakdown from 'src/components/analytics/PopinsBreakdown';
import UpcomingPopinsBreakdown from 'src/components/analytics/UpcomingPopinsBreakdown';
import Dropdown from 'src/components/shared/Dropdown';
import { API_POPIN_PREFIX } from 'src/constants';
import { StatFilters } from 'src/models/StatFilters';
import { fetchTenantStats } from 'src/actions/tenantStats';
import { EnterpriseAnalytics } from 'src/analytics/EnterpriseAnalytics';
import { NavigationUtils } from 'src/util/NavigationUtils';
import { BrowserChecker } from 'src/BrowserChecker';
import { ScreenRecorder } from 'src/util/ScreenRecorder';

import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';  // For converting charts to images
import autoTable from 'jspdf-autotable';

import TenantHero from '../../models/TenantHero';
import DateTime from '../../models/DateTime';

//import { Spinner } from 'react-bootstrap';

//import html2pdf from 'html2pdf.js';  // Import the html2pdf library

// import DateTime from '../models/DateTime';

class Analytics extends React.Component {

  // working fine 2
  // captureChart = async (selector, pdf, yOffset) => {
  //   const chartElement = document.querySelector(selector);
  //   if (chartElement) {

  //     // Adding a small border or padding to ensure the boundaries are captured
  //     chartElement.style.border = "2px solid #000"; // Optional: adjust border color and size as needed
  //     chartElement.style.padding = "10px"; // Optional: adding padding to give space around the chart

  //     const canvas = await html2canvas(chartElement, {
  //       scale: 3,  // Increase scale for better image quality
  //       useCORS: true // Ensures external resources like images are captured properly
        
  //     });
  
  //     const imgData = canvas.toDataURL('image/jpeg', 1.0);  // Use JPEG for better quality
  //     const imgWidth = 190;  // Width in mm for the PDF
  //     const imgHeight = (canvas.height * imgWidth) / canvas.width;  // Maintain aspect ratio
  
  //     // Check if image fits on the current page
  //     if (yOffset + imgHeight > 270) {  // 270 is approximate bottom margin for letter size
  //       pdf.addPage();  // Add a new page if it exceeds the page height
  //       yOffset = 30;  // Reset yOffset to top margin
  //     }
  
  //     pdf.addImage(imgData, 'JPEG', 10, yOffset, imgWidth, imgHeight);
  
  //     return yOffset + imgHeight + 10;  // Return new yOffset for next chart
  //   }
  //   return yOffset;  // Return unchanged yOffset if chart not found
  // };
   
  
  // handlePdfDownloadClicked = async () => {

  //   this.setState({ isPDFReportLoading: true });

  //   const pdf = new jsPDF('portrait', 'mm', 'letter');

  //   const headerMargin = 20;
  //   const footerMargin = 20;
  //   const contentHeight = 270 - headerMargin - footerMargin;
  //   let yOffset = headerMargin + 30;  // Start content below the title

    
  //   // Capture and add the organization name from the div
  //   const orgName = document.querySelector('.navbar-org-name')?.textContent || 'Organization Name';
   
  //   // Add title with formatting
  //   pdf.setFontSize(22);
  //   pdf.setTextColor(40, 40, 40);  // Dark gray
  //   pdf.text('Enterprise Dashboard Report', 10, 20);
  //   pdf.text(`Organization: ${orgName}`, 10, 30);

    
  //   // Add subtitle or description if necessary
  //   pdf.setFontSize(12);
  //   pdf.text('Generated on: ' + new Date().toLocaleDateString(), 10, 40);
    
  //   //let yOffset = 50;  // Start the charts after the title
  
  //   // Capture each chart and adjust yOffset dynamically
  //   yOffset = await this.captureChart('.stats-overview-selector', pdf, yOffset);
  //   //yOffset = await this.captureChart('.donut-chart-usage-selector', pdf, yOffset); //chart was duplicated so removed it...akmal
  //   yOffset = await this.captureChart('.activities-by-usecase-selector', pdf, yOffset);
  //   yOffset = await this.captureChart('.active-users-selector', pdf, yOffset);
  //   yOffset = await this.captureChart('.active-heroes-selector', pdf, yOffset);
  //   yOffset = await this.captureChart('.popins-breakdown-selector', pdf, yOffset);
  //   yOffset = await this.captureChart('.upcoming-popins-selector', pdf, yOffset);
  
  //   // Save the generated PDF
  //   pdf.save('Enterprise-Dashboard-report.pdf');
  //   this.setState({ isPDFReportLoading: false });
  // };

  // try 5th
//   captureChart = async (selector, pdf, yOffset, contentHeight) => {
//     const chartElement = document.querySelector(selector);
//     if (chartElement) {

//       // Adding border and padding to ensure boundaries are captured
//       chartElement.style.border = "2px solid #000";  // Optional: adjust color and size
//       chartElement.style.padding = "10px";  // Optional: add padding around chart

//       const canvas = await html2canvas(chartElement, {
//         scale: 3,  // Increase scale for better quality
//         useCORS: true  // Ensure external resources like images are captured
//       });

//       const imgData = canvas.toDataURL('image/jpeg', 1.0);  // Use JPEG for better quality
//       const imgWidth = 190;  // Width in mm for the PDF
//       const imgHeight = (canvas.height * imgWidth) / canvas.width;  // Maintain aspect ratio

//       // Check if image fits on the current page
//       if (yOffset + imgHeight > contentHeight) {  // contentHeight is adjusted for header/footer
//         pdf.addPage();  // Add new page if it exceeds the page height
//         yOffset = 30;  // Reset yOffset to top margin (adjust as needed)
//       }

//       pdf.addImage(imgData, 'JPEG', 10, yOffset, imgWidth, imgHeight);

//       return yOffset + imgHeight + 10;  // Return new yOffset for next chart
//     }
//     return yOffset;  // Return unchanged yOffset if chart not found
// };

// handlePdfDownloadClicked = async () => {
//     this.setState({ isPDFReportLoading: true });

//     const pdf = new jsPDF('portrait', 'mm', 'letter');
    
//     // Define header and footer margins
//     const headerMargin = 20;
//     const footerMargin = 20;
//     const contentHeight = 270 - headerMargin - footerMargin;  // Adjusted height for content

//     // Capture and add organization name
//     const orgName = document.querySelector('.navbar-org-name')?.textContent || 'Organization Name';

//     // Add title and organization name
//     pdf.setFontSize(22);
//     pdf.setTextColor(40, 40, 40);  // Dark gray
//     pdf.text('Enterprise Dashboard Report', 10, headerMargin);
//     pdf.text(`Organization: ${orgName}`, 10, headerMargin + 10);

//     // Add generated date
//     pdf.setFontSize(12);
//     pdf.text('Generated on: ' + new Date().toLocaleDateString(), 10, headerMargin + 20);

//     let yOffset = headerMargin + 30;  // Start yOffset for charts below the title

    
    
//     // Capture each chart and adjust yOffset dynamically
//     yOffset = await this.captureChart('.stats-overview-selector', pdf, yOffset, contentHeight);
//     yOffset = await this.captureChart('.activities-by-usecase-selector', pdf, yOffset, contentHeight);
//     yOffset = await this.captureChart('.active-users-selector', pdf, yOffset, contentHeight);
//     // yOffset = await this.captureChart('.active-heroes-selector', pdf, yOffset, contentHeight);
//     yOffset = await this.captureChart('.popins-breakdown-selector', pdf, yOffset, contentHeight);
//     yOffset = await this.captureChart('.upcoming-popins-selector', pdf, yOffset, contentHeight);

//     // Handle tabular data with autoTable for pagination
//     const tableData = Array.from(document.querySelectorAll(".active-heroes-selector tr"))
//         .map(row => Array.from(row.querySelectorAll("td, th")).map(cell => cell.innerText));

//     pdf.autoTable({
//         startY: yOffset,
//         head: [tableData[0]],  // Use first row as table header
//         body: tableData.slice(1),  // Remaining rows as table body
//         theme: 'grid',  // 'grid' theme for table styling
//         margin: { top: headerMargin, bottom: footerMargin },
//         styles: { fontSize: 10, overflow: 'linebreak' },
//         pageBreak: 'auto'  // Automatically handle page breaks for large tables
//     });

//     // Add page numbers as footer on each page
//     const totalPages = pdf.internal.getNumberOfPages();
//     for (let i = 1; i <= totalPages; i++) {
//       pdf.setPage(i);
//       pdf.setFontSize(10);
//       pdf.text(`Page ${i} of ${totalPages}`, pdf.internal.pageSize.width - 20, pdf.internal.pageSize.height - footerMargin);
//     }

//     // Save the generated PDF
//     pdf.save('Enterprise-Dashboard-report.pdf');
//     this.setState({ isPDFReportLoading: false });
// };

// 6th try
// handlePdfDownloadClicked = async () => {
//     this.setState({ isPDFReportLoading: true });

//     const pdf = new jsPDF('portrait', 'mm', 'letter');

//     const headerMargin = 20;
//     const footerMargin = 20;
//     const contentHeight = 270 - headerMargin - footerMargin;
//     const pageWidth = pdf.internal.pageSize.width;
//     const orgName = document.querySelector('.navbar-org-name')?.textContent || 'Organization Name';

//     pdf.setFontSize(22);
//     pdf.setTextColor(40, 40, 40);
//     pdf.text('Enterprise Dashboard Report', 10, headerMargin);
//     pdf.text(`Organization: ${orgName}`, 10, headerMargin + 10);

//     pdf.setFontSize(12);
//     pdf.text('Generated on: ' + new Date().toLocaleDateString(), 10, headerMargin + 20);

//     let yOffset = headerMargin + 30;

//     // Capture other non-tabular charts
//     yOffset = await this.captureChart('.stats-overview-selector', pdf, yOffset, contentHeight);
//     yOffset = await this.captureChart('.activities-by-usecase-selector', pdf, yOffset, contentHeight);
//     yOffset = await this.captureChart('.active-users-selector', pdf, yOffset, contentHeight);
    
//     // Directly access and format heroes data for the table
//     const { heroes } = this.props;
//     console.log("Heroes data:", this.props.heroes);
//     if (heroes && heroes.length > 0) {

//         // Add a title above the table
//         pdf.setFontSize(16);
//         pdf.setTextColor(0, 102, 204);  // Custom color for title
//         pdf.text("POPin Creators", 10, yOffset);  // Title text
//         yOffset += 10;  // Adjust yOffset to add space below the title

//         // Format heroes data
//         const columns = ['Name', 'Email', 'POPins', 'Reach', 'Last POPin']; // removed 'ID',
//         const rows = heroes.map(hero => {
//             // const id = TenantHero.getId(hero);
//             const name = TenantHero.getName(hero);
//             const email = TenantHero.getEmail(hero);
//             const popins = TenantHero.getPopins(hero);
//             const reach = TenantHero.getReach(hero);
//             const lastTime = TenantHero.getLastPopin(hero);
//             const lastPopin = (lastTime === null)
//                 ? 'Not Available'
//                 : DateTime.format(DateTime.unixSecondsToMoment(lastTime), 'MMM D, YYYY');
//             return [name, email, popins, reach, lastPopin]; // removed id as it's not needed
//         });

//         // Generate table with autoTable
//         pdf.autoTable({
//             startY: yOffset,
//             head: [columns],
//             body: rows,
//             // theme: 'grid',
//             // margin: { top: headerMargin, bottom: footerMargin },
//             styles: { fontSize: 10, overflow: 'linebreak' },
//             pageBreak: 'auto',
//             theme: 'striped',  // Use 'striped' theme for alternate row colors
//             margin: { top: headerMargin, bottom: footerMargin },
//             headStyles: { fillColor: [0, 102, 204], textColor: [255, 255, 255], fontStyle: 'bold' },  // Header style
//             bodyStyles: { textColor: [0, 0, 0] },  // Body text color
//             alternateRowStyles: { fillColor: [240, 240, 240] },  // Alternate row color
//         });
//         yOffset = pdf.lastAutoTable.finalY + 10;  // Update yOffset after the table
//     } else {
//         console.warn("No data available for ActiveHeroes table.");
//     }

//     // Check if there's enough space for the next chart
//     if (yOffset + 60 > contentHeight) {  // Estimate 60mm for chart height
//       pdf.addPage();
//       yOffset = headerMargin;
//   }

//     // Capture remaining charts after the autoTable POPin Creators
//     yOffset = await this.captureChart('.popins-breakdown-selector', pdf, yOffset, contentHeight);
//     yOffset = await this.captureChart('.upcoming-popins-selector', pdf, yOffset, contentHeight);


//     // Add page numbers as footer on each page
//     // const totalPages = pdf.internal.getNumberOfPages();
//     // for (let i = 1; i <= totalPages; i++) {
//     //     pdf.setPage(i);
//     //     pdf.setFontSize(10);
//     //     pdf.text(`Page ${i} of ${totalPages}`, pdf.internal.pageSize.width - 20, pdf.internal.pageSize.height - footerMargin);
//     // }

//     // Add centered page numbers as footer on each page
//     const totalPages = pdf.internal.getNumberOfPages();
//     for (let i = 1; i <= totalPages; i++) {
//         pdf.setPage(i);
//         pdf.setFontSize(10);
//         const pageNumberText = `Page ${i} of ${totalPages}`;
//         const textWidth = pdf.getTextWidth(pageNumberText);
//         pdf.text(pageNumberText, (pageWidth - textWidth) / 2, pdf.internal.pageSize.height - footerMargin);
//     }


//     // Save the generated PDF
//     pdf.save('Enterprise-Dashboard-report.pdf');
//     this.setState({ isPDFReportLoading: false });
// };

// Helper function to capture non-tabular charts
captureChart = async (selector, pdf, yOffset, contentHeight) => {
    const chartElement = document.querySelector(selector);
    if (chartElement) {
        chartElement.style.border = "2px solid #000";
        chartElement.style.padding = "10px";

        const canvas = await html2canvas(chartElement, {
            scale: 3,
            useCORS: true
        });

        const imgData = canvas.toDataURL('image/jpeg', 1.0);
        const imgWidth = 190;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        if (yOffset + imgHeight > contentHeight) {
            pdf.addPage();
            yOffset = 30;
        }

        pdf.addImage(imgData, 'JPEG', 10, yOffset, imgWidth, imgHeight);
        return yOffset + imgHeight + 10;
    }
    return yOffset;
};

// 8th try
handlePdfDownloadClicked = async () => {
  this.setState({ isPDFReportLoading: true });

  const pdf = new jsPDF('portrait', 'mm', 'letter');
  const headerMargin = 20;
  const footerMargin = 20;
  const contentHeight = 270 - headerMargin - footerMargin;
  const pageWidth = pdf.internal.pageSize.width;
  const orgName = document.querySelector('.navbar-org-name')?.textContent || 'Organization Name';

  pdf.setFontSize(22);
  pdf.setTextColor(40, 40, 40);
  pdf.text('Enterprise Dashboard Report', 10, headerMargin);
  pdf.text(`Organization: ${orgName}`, 10, headerMargin + 10);

  pdf.setFontSize(12);
  pdf.text('Generated on: ' + new Date().toLocaleDateString(), 10, headerMargin + 20);

  let yOffset = headerMargin + 30;

  // Capture initial charts
  yOffset = await this.captureChart('.stats-overview-selector', pdf, yOffset, contentHeight);
  yOffset = await this.captureChart('.activities-by-usecase-selector', pdf, yOffset, contentHeight);
  yOffset = await this.captureChart('.active-users-selector', pdf, yOffset, contentHeight);

  // Get sorted heroes data
  const heroesToDisplay = this.getHeroes();
  if (heroesToDisplay.length > 0) {
      pdf.setFontSize(16);
      pdf.setTextColor(0, 102, 204);
      pdf.text("POPin Creators", 10, yOffset);
      yOffset += 10;

      const columns = ['Name', 'Email', 'POPins', 'Reach', 'Last POPin'];
      pdf.autoTable({
          startY: yOffset,
          head: [columns],
          body: heroesToDisplay,
          theme: 'striped',
          margin: { top: headerMargin, bottom: footerMargin },
          headStyles: { fillColor: [0, 102, 204], textColor: [255, 255, 255], fontStyle: 'bold' },
          bodyStyles: { textColor: [0, 0, 0] },
          alternateRowStyles: { fillColor: [240, 240, 240] },
          styles: { fontSize: 10, overflow: 'linebreak' },
          pageBreak: 'auto'
      });
      yOffset = pdf.lastAutoTable.finalY + 10;
  } else {
      console.warn("No data available for ActiveHeroes table.");
  }

  // Check for remaining charts
  if (yOffset + 60 > contentHeight) {
      pdf.addPage();
      yOffset = headerMargin;
  }
  yOffset = await this.captureChart('.popins-breakdown-selector', pdf, yOffset, contentHeight);
  yOffset = await this.captureChart('.upcoming-popins-selector', pdf, yOffset, contentHeight);

  // Add centered page numbers
  const totalPages = pdf.internal.getNumberOfPages();
  for (let i = 1; i <= totalPages; i++) {
      pdf.setPage(i);
      pdf.setFontSize(10);
      const pageNumberText = `Page ${i} of ${totalPages}`;
      const textWidth = pdf.getTextWidth(pageNumberText);
      pdf.text(pageNumberText, (pageWidth - textWidth) / 2, pdf.internal.pageSize.height - footerMargin);
  }

  // Save the generated PDF
  pdf.save('Enterprise-Dashboard-report.pdf');
  this.setState({ isPDFReportLoading: false });
};

getHeroes = () => {
  const { heroes } = this.props;
  if (heroes && heroes.length > 0) {
      return heroes
          .map(hero => ({
              name: TenantHero.getName(hero),
              email: TenantHero.getEmail(hero),
              popins: TenantHero.getPopins(hero),
              reach: TenantHero.getReach(hero),
              lastTime: TenantHero.getLastPopin(hero),
              lastPopin: TenantHero.getLastPopin(hero)
                  ? DateTime.format(DateTime.unixSecondsToMoment(TenantHero.getLastPopin(hero)), 'MMM D, YYYY')
                  : 'Not Available'
          }))
          .sort((a, b) => (b.lastTime || 0) - (a.lastTime || 0)) // Sort once by Last POPin date
          .map(hero => [hero.name, hero.email, hero.popins, hero.reach, hero.lastPopin]);  // Return formatted data
  }
  return [];
};


// 7th try...takes lot of time for pdf generation..also empty table for now

// handlePdfDownloadClicked = async () => {
//     this.setState({ isPDFReportLoading: true });

//     const pdf = new jsPDF('portrait', 'mm', 'letter');
//     const headerMargin = 20;
//     const footerMargin = 20;
//     const contentHeight = 270 - headerMargin - footerMargin;
//     const pageWidth = pdf.internal.pageSize.width;

//     const orgName = document.querySelector('.navbar-org-name')?.textContent || 'Organization Name';

//     pdf.setFontSize(22);
//     pdf.setTextColor(40, 40, 40);
//     pdf.text('Enterprise Dashboard Report', 10, headerMargin);
//     pdf.text(`Organization: ${orgName}`, 10, headerMargin + 10);

//     pdf.setFontSize(12);
//     pdf.text('Generated on: ' + new Date().toLocaleDateString(), 10, headerMargin + 20);

//     let yOffset = headerMargin + 30;

//     // Capture initial charts with html2canvas
//     yOffset = await this.captureChart('.stats-overview-selector', pdf, yOffset, contentHeight);
//     yOffset = await this.captureChart('.activities-by-usecase-selector', pdf, yOffset, contentHeight);
//     yOffset = await this.captureChart('.active-users-selector', pdf, yOffset, contentHeight);

//     // Add POPin Creators table using autoTable
//     const heroesToDisplay = this.getHeroes();
//     if (heroesToDisplay && heroesToDisplay.length > 0) {
//         pdf.setFontSize(16);
//         pdf.setTextColor(0, 102, 204);
//         pdf.text("POPin Creators", 10, yOffset);
//         yOffset += 10;

//         const columns = ['Name', 'Email', 'POPins', 'Reach', 'Last POPin'];
//         pdf.autoTable({
//             startY: yOffset,
//             head: [columns],
//             body: heroesToDisplay,
//             theme: 'striped',
//             margin: { top: headerMargin, bottom: footerMargin },
//             headStyles: { fillColor: [0, 102, 204], textColor: [255, 255, 255], fontStyle: 'bold' },
//             bodyStyles: { textColor: [0, 0, 0] },
//             alternateRowStyles: { fillColor: [240, 240, 240] },
//             styles: { fontSize: 10, overflow: 'linebreak' },
//             pageBreak: 'auto'
//         });

//         yOffset = pdf.lastAutoTable.finalY + 10;
//     } else {
//         console.warn("No data available for POPin Creators table.");
//     }

//     // Check if there's enough space for the next chart
//     if (yOffset + 60 > contentHeight) {
//         pdf.addPage();
//         yOffset = headerMargin;
//     }

//     // Capture remaining charts after the autoTable
//     yOffset = await this.captureChart('.popins-breakdown-selector', pdf, yOffset, contentHeight);
//     yOffset = await this.captureChart('.upcoming-popins-selector', pdf, yOffset, contentHeight);

//     // Add centered page numbers as footer on each page
//     const totalPages = pdf.internal.getNumberOfPages();
//     for (let i = 1; i <= totalPages; i++) {
//         pdf.setPage(i);
//         pdf.setFontSize(10);
//         const pageNumberText = `Page ${i} of ${totalPages}`;
//         const textWidth = pdf.getTextWidth(pageNumberText);
//         pdf.text(pageNumberText, (pageWidth - textWidth) / 2, pdf.internal.pageSize.height - footerMargin);
//     }

//     // Save the generated PDF
//     pdf.save('Enterprise-Dashboard-report.pdf');
//     this.setState({ isPDFReportLoading: false });
// };

// // Helper function to capture non-tabular charts
// captureChart = async (selector, pdf, yOffset, contentHeight) => {
//     const chartElement = document.querySelector(selector);
//     if (chartElement) {
//         chartElement.style.border = "2px solid #000";
//         chartElement.style.padding = "10px";

//         const canvas = await html2canvas(chartElement, {
//             scale: 3,
//             useCORS: true
//         });

//         const imgData = canvas.toDataURL('image/jpeg', 1.0);
//         const imgWidth = 190;
//         const imgHeight = (canvas.height * imgWidth) / canvas.width;

//         if (yOffset + imgHeight > contentHeight) {
//             pdf.addPage();
//             yOffset = 30;
//         }

//         pdf.addImage(imgData, 'JPEG', 10, yOffset, imgWidth, imgHeight);
//         return yOffset + imgHeight + 10;
//     }
//     return yOffset;
// };

// Efficiently fetch and sort heroes data by Last POPin date
// getHeroes = () => {
//     const { heroes } = this.props;
//     if (heroes && heroes.length > 0) {
//         const sortedHeroes = heroes.map(hero => {
//             //const id = hero[0];
//             const name = hero[1];
//             const email = hero[2];
//             const popins = hero[3];
//             const reach = hero[4];
//             const lastPopin = hero[5];
//             const lastPopinDate = lastPopin === 'Not Available' ? 0 : new Date(lastPopin).getTime();
//             return { name, email, popins, reach, lastPopin, lastPopinDate };
//         }).sort((a, b) => b.lastPopinDate - a.lastPopinDate);

//         return sortedHeroes.map(hero => [
//             //hero.id,
//             hero.name,
//             hero.email,
//             hero.popins,
//             hero.reach,
//             hero.lastPopin
//         ]);
//     }
//     console.warn("No heroes data available.");
//     return [];
// };

  

  
  handleDateRangeSelect = (item) => {
    const prevDateRange = this.state.dateRange.value;
    const nextDateRange = item.value;
    EnterpriseAnalytics.dateRangeSwitched(prevDateRange, nextDateRange);
    this.setState({ dateRange: item });
  };
  getDownloadUrl = () => {
    const { user } = this.props;
    const numWeeks = this.state.dateRange.value;
    const tenantId = Tenant.getId(User.getTenant(user));
    let url = `${API_POPIN_PREFIX}/admin/tenants/${tenantId}/stats/export?type=csv`;
    if (numWeeks) { // if numWeeks !== null, we tack a param on that limits the timeframe of the data returned
      url += `&num_weeks=${numWeeks}`;
    }
    return url;
  };
  handleCsvDownloadClicked = ($event) => {
    $event.preventDefault();
    NavigationUtils.openTab(this.getDownloadUrl());
    EnterpriseAnalytics.exportedCSV();
  };

  // The analytics page does not directly fetch stats anymore, but we still need this here
  // because the Architecture around the Donut charts uses it.
  fetchStats = () => {
    const { user, fetchTenantStats } = this.props;
    const { dateRange } = this.state;
    fetchTenantStats(Tenant.getId(User.getTenant(user)), dateRange.value);
  };

  constructor (props) {
    super(props);
    TrackingAnalytics.mixpanelTrackPageViewed();

    this.state = {
      isPDFReportLoading: false,
      dateRange: { text: 'Last 12 Weeks', id: StatFilters.LAST_12_WEEKS, value: 12 }
    };

    // Mobile blocked from Org dash
    if (BrowserChecker.isMobile()) {
      NavigationUtils.backToPopin();
    }
  }

  componentDidMount () {
    const { sessionCheck } = this.props;
    sessionCheck(true);

    // Scroll to page top on initial page load
    window.scrollTo(0, 0);
  }

  componentDidUpdate (prevProps) {
    const { user, userError } = this.props;
    if (!prevProps.user && !!user) {
      ScreenRecorder.record(false);
    }

    handleErrorWithDialog(userError, prevProps.userError,
      'Unable to load your Account, please try again later');
  }

  setComponentRef = ($element) => {
    TrackingAnalytics.listenForActiveUser($element, 'Analytics');
  };

  render () {
    const { dateRange } = this.state;
    const { user, stats, prevStats, statsError, loading } = this.props;
    const usageByDevice = stats ? TenantStats.getUsageByDevice(stats) : null;
    const usageByDevicePrev = prevStats ? TenantStats.getUsageByDevice(prevStats) : null;
    const popinsByUseCase = stats ? TenantStats.getPopinsByUseCase(stats) : null;
    const popinsByUseCasePrev = prevStats ? TenantStats.getPopinsByUseCase(prevStats) : null;

    const { isPDFReportLoading } = this.state;  // Access the state
    
    if (!user) {
      return (
        <div className="org-dash analytics-loading container py-3" ref={ this.setComponentRef }>
          <div className="content">Loading...</div>
        </div>
      );
    } else {
      return (
        <div className="org-dash container py-3" ref={ this.setComponentRef }>
          <div className="content col">

            <div className="row no-gutters d-flex h-100">
              <div className="p-2">
                <button onClick={ this.handleCsvDownloadClicked } className="btn pop-btn">Export CSV
                </button>
              </div>

              <div className="p-2">
                {/* <button onClick={this.handlePdfDownloadClicked} className="btn pop-btn">Export PDF</button> */}
                <button onClick={this.handlePdfDownloadClicked} className="btn pop-btn" disabled={isPDFReportLoading}>
                  {isPDFReportLoading ? 'Generating PDF...' : 'Export PDF'}
                </button>

                {/* Loading Spinner */}
                {/* {isPDFReportLoading && (
                  <div className="text-center my-3">
                    <Spinner animation="border" role="status">
                      <span className="sr-only">Generating Report...</span>
                    </Spinner>
                    <p>Please wait while the report is being generated...</p>
                  </div>
                )} */}

              </div>
              
              <div className="fix-ie" />
              <div className="p-2 d-flex h-100">
                <span className="date-range-limit-label m-auto">Filter</span>
                <div className="d-flex h-100 ml-3">
                  <div className="m-auto h-100">
                    <Dropdown
                      id="date-range-limit-dropdown"
                      text={ this.state.dateRange.text }
                      itemList={ [
                        { text: 'Last 12 Weeks', id: StatFilters.LAST_12_WEEKS, value: 12 },
                        { text: 'Last Year', id: StatFilters.LAST_12_MONTHS, value: 52 },
                        { text: 'All Time', id: StatFilters.ALL_TIME, value: null }
                      ] }
                      onSelected={ this.handleDateRangeSelect }
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="row stats-overview-selector">
              <div className="col-md-8 col-sm-12 pr-md-0" >
                <StatsOverview dateRange={ dateRange } />
              </div>
              <div className="col-md-4 col-sm-12 pl-md-0 donut-chart-usage-selector">
                <DonutChartCard
                  user={ user }
                  icon={ devices }
                  title="USAGE BY DEVICE"
                  loading={ loading }
                  tooltipLabel="Activities"
                  data={ usageByDevice }
                  prevData={ usageByDevicePrev }
                  dateRange={ dateRange }
                  error={ statsError }
                  onRefresh={ this.fetchStats }
                  diffCount={ StringUtils.roundThousands(
                    TenantStats.getDiffCountHeroes(stats, prevStats)) }
                  diffPercent={ TenantStats.getDiffPercentHeroes(stats, prevStats) }
                />
              </div>
            </div>

            <div className="row activities-by-usecase-selector">
              <div className="col-md-8 col-sm-12 pr-md-0">
                <ActivitiesByUseCase dateRange={ dateRange } />
              </div>
              <div className="col-md-4 col-sm-12 pl-md-0">
                <DonutChartCard
                  user={ user }
                  icon={ arrows }
                  title="POPins BY USE CASE"
                  loading={ loading }
                  tooltipLabel="POPins"
                  data={ popinsByUseCase }
                  prevData={ popinsByUseCasePrev }
                  dateRange={ dateRange }
                  error={ statsError }
                  onRefresh={ this.fetchStats }
                  diffCount={ StringUtils.roundThousands(
                    TenantStats.getDiffCountHeroes(stats, prevStats)) }
                  diffPercent={ TenantStats.getDiffPercentHeroes(stats, prevStats) }
                />
              </div>
            </div>

            <div className="row active-users-selector">
              <div className="col-md-12">
                <ActiveUsers dateRange={ dateRange } />
              </div>
            </div>

            <div className="row active-heroes-selector">
              <div className="col-md-12">
                <ActiveHeroes dateRange={ dateRange } />
              </div>
            </div>

            <div className="row popins-breakdown-selector">
              <div className="col-md-12">
                <PopinsBreakdown dateRange={ dateRange } />
              </div>
            </div>

            <div className="row upcoming-popins-selector">
              <div className="col-md-12">
                <UpcomingPopinsBreakdown dateRange={ dateRange } />
              </div>
            </div>

          </div>
        </div>
      );
  
    }
  }
}

// const mapStateToProps = state => {
//   return {
//     user: state.user.user,
//     userError: state.user.error,
//     loading: state.tenantStats.statsLoading,
//     stats: state.tenantStats.statsOverview,
//     prevStats: state.tenantStats.statsOverviewPrev,
//     statsLoading: state.tenantStats.statsLoading,
//     statsError: state.tenantStats.statsError
//   };
// };

const mapStateToProps = state => {
  return {
    user: state.user.user,
    userError: state.user.error,
    loading: state.tenantStats.statsLoading,
    stats: state.tenantStats.statsOverview,
    prevStats: state.tenantStats.statsOverviewPrev,
    statsLoading: state.tenantStats.statsLoading,
    statsError: state.tenantStats.statsError,
    heroes: state.tenantStats.heroes  // Added heroes to mapStateToProps
  };
};


export default connect(mapStateToProps, { sessionCheck, fetchTenantStats })(Analytics);

